module.exports = __webpack_public_path__ + "static/media/event.5aa65cfd.png";